<template>
  <a-layout class="index animated fadeIn">
    <a-card :bordered="false">
      <a-card
        class="mt-10 mb-30"
        style="background-color: #f2f2f2"
        :bordered="false"
      >
        <a-button
          size="small"
          @click="
            ()=>$router.push('/financial/payments/store?type=2')
          "
        >
          <LeftOutlined />返回
        </a-button>
        <span class="ml-20">{{$route.query.name}}</span>     
      </a-card>
      <a-form
        ref="form"
        :model="search"
        :style="{ marginBottom: '20px' }"
        :initialValues="search"
        :onFinish="pageSearchChange"
        layout="inline"
      >
        <a-form-item label="创建时间" name="">
          <a-range-picker
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
            @change="onChange"
          />
        </a-form-item>
        <a-form-item> </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType="submit">搜索</a-button>
          <a-button class="ml-20" type="" htmlType="submit" v-has:exportRechargeDetailed="exportTable">导出</a-button>
        </a-form-item>
      </a-form>
      <a-col :span="4" class="mb-20">
        <a-card class="">
          <div class="s_flex_bian_c">
            <p>金额 (元)</p>
          </div>
          <p class="s_font_b fz-30 s_c000">{{typeLits.grant_money}}</p>
        </a-card>
      </a-col>
      <a-table
        bordered
        :data-source="dataSource"
        :columns="columns"
        :pagination="false"
        rowKey="id"
        :loading="listLoading"
        class="tableFixBox"
        :scroll="{ x: 'max-content' }"
      >
      </a-table>
      <a-pagination
        :style="{ marginTop: '20px', textAlign: 'right' }"
        show-size-changer
        show-quick-jumper
        :current="search.page"
        :page-size="search.limit"
        :total="total"
        @change="pageCurrentChange"
        @showSizeChange="pageSizeChange"
        :show-total="(total) => `总数: ${total} `"
      />
    </a-card>
  </a-layout>
</template>

<script>
import { ref, onMounted, reactive, toRefs ,inject} from "vue";
import {billConsume,billConsumeGeneral,exportBillConsume} from "@/api/financial";
import { $iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import { LeftOutlined } from "@ant-design/icons-vue";
import config from "@/config";
let defSearch = {
  page: 1,
  limit: 10,
  start_time: "",
  end_time: "",
};
export default {
  name: "agentList",
  components: { LeftOutlined },
  setup(props) {
    let search = ref({ ...defSearch });
    let total = ref(1);
    const state = reactive({
      typeLits: {},
      dataSource: [],
      listLoading: false,
      columns: [
        {
          title: "流水号",
          dataIndex: "billno",
        },
        {
          title: "充值金额",
          dataIndex: "number",
        },
        {
          title: "余额",
          dataIndex: "balance",
        },
        {
          title: "充值时间",
          dataIndex: "create_time",
        },
      ],
    });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
      getType(search.value)
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, size) => {
      search.value.page = 1;
      search.value.limit = size;
      initData(search.value);
    };
    // 导出
    const exportTable = async () => {
      const hide = message.loading("正在加载中...", 0);
      let result = await exportBillConsume({ ...search.value,brand_id: $route.query.id })
        .then((res) => res.data)
        .catch((error) => error);
      if ($iscode(result, true)) {
        window.open(
          config.baseUrl[process.env.VUE_APP_type] + result.data
        );
      }
      setTimeout(hide);
    };
    const getType = async () => {
      let data = {
        ...search.value,
        brand_id: $route.query.id
      }
      let res = await billConsumeGeneral(data).then((res) => res.data);
      if ($iscode(res)) {
        state.typeLits = res.data;
      } else {
        message.error(res.msg);
      }
    };
    const $route = inject("$route");
    //代理商列表
    const initData = async () => {
      state.listLoading = true;
      try {
        let res = await billConsume({...search.value,brand_id: $route.query.id}).then((res) => res.data);
        state.listLoading = false;
        if ($iscode(res)) {
          state.dataSource = res.data.data;
          total.value = res.data.total;
        } else {
          message.error(res.message);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const onChange = (e) => {
      if (e.length > 0) {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      } else {
        search.value.start_time = "";
        search.value.end_time = "";
      }
    };
    onMounted(() => {
      initData(search.value);
      getType();
    });
    return {
      ...toRefs(state),
      initData,
      search,
      total,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      exportTable
    };
  },
};
</script>

<style lang="less"></style>
